// extracted by mini-css-extract-plugin
module.exports = {"container":"DeploymentActivity__container___IkefA","timestamp":"DeploymentActivity__timestamp___lN3ux type__timestamp___rqICu"};